angular.module('zc.zenclerkS')
  .component('zcsChartStackedBar', {
    bindings: {
      chartData: '<',
      dimension: '<',
      chartLegend: '<',
    },
    controller: zcsChartStackedBarController
  });

zcsChartStackedBarController.$inject = ['$element', '$translate'];
function zcsChartStackedBarController($element, $translate) {
  const vm = this;
  vm.$onChanges = changes => {
    // do not react to dimension changes
    if(changes.chartData) {
      drawChart();
    }
  };

  function drawChart() {
    const container = $element;
    container.html('');
    container.append('<div class="chart-primary">');
    container.append('<div class="chart-tertiary">');
    // get color from container
    const colors = [
      angular.element('.chart-primary').css('color'),
      angular.element('.chart-tertiary').css('color'),
    ];

    const tooltipTimeFormatter = vm.dimension === 'hourly'
      ? d3.time.format($translate.instant('sharedModules.dateTimeFormats.chart.monthDayHour'))
      : d3.time.format($translate.instant('sharedModules.dateTimeFormats.chart.monthDay'));

    nv.addGraph(function() {
      const svgContainer = d3.select($element[0]).append('svg');
      const chart = nv.models
        .multiBarChart()
        .showControls(false)
        .showLegend(false)
        .stacked(true)
        //.useInteractiveGuideline(true) // Tooltips which show all data points.
        .reduceXTicks(true)
        .forceY([0, 1])
        .duration(500)
        .color(colors)
        .x(d => moment(d.x).valueOf())
        .y(d => d.y);

      if(vm.chartLegend || angular.isUndefined(vm.chartLegend)) {
        chart.margin({
          top: 10,
          right: 0,
          bottom: 20,
          left: 40
        });
      } else {
        chart.margin({top: 0, right: 0, bottom: 0, left: 0})
          .showXAxis(false)
          .showYAxis(false);
      }

      chart.xAxis.tickFormat(function(d) {
        return tooltipTimeFormatter(new Date(d));
      });

      chart.yAxis.tickFormat(d3.format(',.0d'));

      svgContainer.datum(vm.chartData)
        .transition()
        .duration(500)
        .call(chart);

      nv.utils.windowResize(chart.update);
      return chart;
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/charts/chart_stacked_bar.js